module.exports = __webpack_public_path__ + "img/upload.f6311d93.svg";